export default {
  INIT: 'PROMOCODE/INIT',
  UPDATE_DATA: 'PROMOCODE/UPDATE_DATA',
  UPDATE_META: 'PROMOCODE/UPDATE_META',
  UPDATE_PARAMS: 'PROMOCODE/UPDATE_PARAMS',
}
